var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99325 1.33325C4.31325 1.33325 1.33325 4.31992 1.33325 7.99992C1.33325 11.6799 4.31325 14.6666 7.99325 14.6666C11.6799 14.6666 14.6666 11.6799 14.6666 7.99992C14.6666 4.31992 11.6799 1.33325 7.99325 1.33325ZM7.99992 13.3333C5.05325 13.3333 2.66659 10.9466 2.66659 7.99992C2.66659 5.05325 5.05325 2.66659 7.99992 2.66659C10.9466 2.66659 13.3333 5.05325 13.3333 7.99992C13.3333 10.9466 10.9466 13.3333 7.99992 13.3333ZM8.33325 4.66659H7.33325V8.66659L10.8333 10.7666L11.3333 9.94659L8.33325 8.16659V4.66659Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.fa635e29f4d9f1505c499cb7e403b3c8.svg";
export { ForwardRef as ReactComponent };